import * as React from 'react';
import classNames from 'classnames';
import './sheModal.module.scss';
import { OverlayContent } from './OverlayPage';

type Props = {
    open: boolean;
    onRequestClose: () => any;
    showCloseButton?: boolean;
    modalClassName?: string;
    children: any;
    id?: string;
};

export class SheModal extends React.Component<Props> {
    render() {
        const { open, children, onRequestClose, showCloseButton = true, modalClassName, id } = this.props;
        return (
            <OverlayContent
                open={open}
                onRequestClose={onRequestClose}
                childElem={(st, setRef, options) => {
                    return (
                        <div id={id} styleName="modal">
                            {showCloseButton && (
                                <div styleName="button-wrapper">
                                    <div
                                        id="close-button"
                                        styleName={classNames('close-button', st)}
                                        onClick={onRequestClose}
                                    >
                                        <div styleName={classNames('close-button-inner', st)}>
                                            <div styleName="bar leftright" />
                                            <div styleName="bar rightleft" />
                                        </div>
                                    </div>
                                </div>
                            )}
                            <div
                                styleName={classNames('modal-body', st, {
                                    'vertically-centered': options.verticallyCentered,
                                })}
                                ref={setRef}
                                className={modalClassName}
                            >
                                {children}
                            </div>
                        </div>
                    );
                }}
            />
        );
    }
}
